export default "__VITE_ASSET__rWFscehA__"